import { Helpers } from '../../helpers';
import { ISaltWaterDisposalFacility } from '../../interfaces/isalt-water-disposal-facility';
import { Area } from '../area';
import { Asset } from '../asset';
import { AssetTeam } from '../asset-team';
import { SaltWaterDisposalFacility } from '../salt-water-disposal-facility';
import { SaltWaterDisposalWell } from '../salt-water-disposal-well';
import { TankBattery } from '../tank-battery';
import { Well } from '../well';
import { WellStatus } from '../well-status';

export class SaltWaterDisposalFacilityBase {
  SaltWaterDisposalFacilityId: number;
  Name: string;
  UpdatedBy: string;
  Created: Date;
  Updated: Date;
  CreatedBy: string;
  AssetId: number | null;
  LatitudeLongitudeFinal: boolean | null;
  TRRCPermitSubmittedDate: Date | null;
  TRRCPermitApprovalDate: Date | null;
  PermittedDisposalVolume: number | null;
  TCEQAirPermitRequestSent: boolean | null;
  DrillScheduleSpudDate: Date | null;
  WellStatusId: number | null;
  TargetPadConstructionStartDate: Date | null;
  Comments: string | null;
  WellReleasedByLand: boolean | null;
  TCEQPermitNumber: string | null;
  AssetTeamId: number | null;
  LegacyAssetTeamId: number | null;
  ParentSWDFacilityId: number | null;
  ParentTankBatteryId: number | null;
  AreaId: number | null;
  Location: object | null;
  MaxStorageCapacity: number | null;
  CurrentVolume: number | null;
  WaterDispoalSystemAreaId: number | null;
  TankBatteryAreaId: number | null;

  Wells_SaltWaterDisposalFacility?: Array<Well> | null;
  SaltWaterDisposalFacilities_ParentSWDFacility?: Array<SaltWaterDisposalFacility> | null;
  SaltWaterDisposalWells_ParentSaltWaterFacility?: Array<SaltWaterDisposalWell> | null;
  Area?: Area;
  Asset?: Asset;
  AssetTeam?: AssetTeam;
  WellStatus?: WellStatus;
  LegacyAssetTeam?: AssetTeam;
  ParentSWDFacility?: SaltWaterDisposalFacility;
  TankBattery?: TankBattery;
  TankBatteryArea?: Area;
  WaterDispoalSystemArea?: Area;

  constructor(item?: ISaltWaterDisposalFacility) {
    if (item) {

      this.SaltWaterDisposalFacilityId = item.SaltWaterDisposalFacilityId;
      this.Name = item.Name;
      this.UpdatedBy = item.UpdatedBy;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.CreatedBy = item.CreatedBy;
      this.AssetId = item.AssetId;
      this.LatitudeLongitudeFinal = item.LatitudeLongitudeFinal;
      this.TRRCPermitSubmittedDate = item.TRRCPermitSubmittedDate ? new Date(item.TRRCPermitSubmittedDate) : null;
      this.TRRCPermitApprovalDate = item.TRRCPermitApprovalDate ? new Date(item.TRRCPermitApprovalDate) : null;
      this.PermittedDisposalVolume = item.PermittedDisposalVolume;
      this.TCEQAirPermitRequestSent = item.TCEQAirPermitRequestSent;
      this.DrillScheduleSpudDate = item.DrillScheduleSpudDate ? new Date(item.DrillScheduleSpudDate) : null;
      this.WellStatusId = item.WellStatusId;
      //PadConstrution project type is now Surface Development (9/11/2023), this may need change also?
      this.TargetPadConstructionStartDate = item.TargetPadConstructionStartDate ? new Date(item.TargetPadConstructionStartDate) : null;
      this.Comments = item.Comments;
      this.WellReleasedByLand = item.WellReleasedByLand;
      this.TCEQPermitNumber = item.TCEQPermitNumber;
      this.AssetTeamId = item.AssetTeamId;
      this.LegacyAssetTeamId = item.LegacyAssetTeamId;
      this.ParentSWDFacilityId = item.ParentSWDFacilityId;
      this.ParentTankBatteryId = item.ParentTankBatteryId;
      this.AreaId = item.AreaId;
      this.Location = item.Location;
      this.MaxStorageCapacity = item.MaxStorageCapacity;
      this.CurrentVolume = item.CurrentVolume;
      this.WaterDispoalSystemAreaId = item.WaterDispoalSystemAreaId;
      this.TankBatteryAreaId = item.TankBatteryAreaId;

      this.Wells_SaltWaterDisposalFacility = Helpers.createClassArray(Well, item.Wells_SaltWaterDisposalFacility);
      this.SaltWaterDisposalFacilities_ParentSWDFacility = Helpers.createClassArray(SaltWaterDisposalFacility, item.SaltWaterDisposalFacilities_ParentSWDFacility);
      this.SaltWaterDisposalWells_ParentSaltWaterFacility = Helpers.createClassArray(SaltWaterDisposalWell, item.SaltWaterDisposalWells_ParentSaltWaterFacility);
      this.Area = new Area(item.Area);
      this.Asset = new Asset(item.Asset);
      this.AssetTeam = new AssetTeam(item.AssetTeam);
      this.WellStatus = new WellStatus(item.WellStatus);
      this.LegacyAssetTeam = new AssetTeam(item.LegacyAssetTeam);
      this.ParentSWDFacility = new SaltWaterDisposalFacility(item.ParentSWDFacility);
      this.TankBattery = new TankBattery(item.TankBattery);
      this.TankBatteryArea = new Area(item.TankBatteryArea);
      this.WaterDispoalSystemArea = new Area(item.WaterDispoalSystemArea);
    }
  }
}